import React, { useState } from 'react';
import { Calendar } from 'primereact/calendar';
import { TabView, TabPanel } from 'primereact/tabview';
import TransactionFee from './TransactionFee';
import DisbursmentFee from './DisbursmentFee';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

const MerchantFees = () => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    return (
        <div className="p-4">
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>Merchant Fees</h3>
                <div className="flex gap-2">
                    <Calendar value={startDate} onChange={(e) => setStartDate(e.value)} placeholder="Start Date" dateFormat="yy-mm-dd" showIcon />
                    <Calendar value={endDate} onChange={(e) => setEndDate(e.value)} placeholder="End Date" dateFormat="yy-mm-dd" showIcon />
                </div>
            </div>
            <TabView>
                <TabPanel header="Transaction Fee">
                    <TransactionFee />
                </TabPanel>
                <TabPanel header="Disbursment Fee">
                    <DisbursmentFee />
                </TabPanel>
            </TabView>
        </div>
    );
};

export default MerchantFees;
